var _defs, _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "bite"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 50,
    r: 7,
    fill: "#000000"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 49,
    fill: "#000000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    mask: "url(#bite)",
    fill: "#ffffff",
    d: "M50 38C45 33 35 33 31 42C27 50 29 62 36 71C40 76 45 76 50 75C55 76 60 76 64 71C71 62 73 50 69 42C65 33 55 33 50 38Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    transform: "translate(-3 -1)",
    d: "M52 34C52 27 57 23 62 23C62 29 58 34 52 34Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIos);
export default __webpack_public_path__ + "static/media/ios.7416eda4d825fc0dbe727b10c02ee373.svg";
export { ForwardRef as ReactComponent };